// extracted by mini-css-extract-plugin
export default {"fs12":"ManageType_fs12__LVtJK","discountAppear":"ManageType_discountAppear__cLT8E","oldPrice":"ManageType_oldPrice__jBEDt"};